import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Pagination from "react-js-pagination";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as vettingUserActions from "../../../actions/admin/vettinguser/vettingUserActions.js";
import * as adminIndex from "../../../actions/admin/Index/adminIndexAction";
import Switch from "react-switch";

class SpecilaistUserList extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			specialistList: [],
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			status: true
		};
		this.sortChanged = this.sortChanged.bind(this)
		this.changeSpecialistType = this.changeSpecialistType.bind(this)
		this.handleChange = this.handleChange.bind(this)
	}

	componentWillMount() {
		let objectDocument = {
			page: this.state.activePage,
			count: this.state.count,
			status: this.state.status,
			userId: localStorage.getItem("userId")
		};
		this.setState({ status: true })
		this.props.adminIndex.changeSpecialistType(true)
		this.props.actions.getAllSpecialists(objectDocument);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			specialistList: nextProps.specialistList,
			totalCount: nextProps.specialistListCount,
		});
	}
	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	changeSpecialistType(status) {

		this.setState({ status: status })
		let objectDocument = {
			page: 1,
			count: this.state.count,
			status: status,
			userId: localStorage.getItem("userId")
		};
		console.log("daaaata changed to ", status)
		this.props.actions.getAllSpecialists(objectDocument);
		this.props.adminIndex.changeSpecialistType(status)
	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		// let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let appointmentObj = {
			token: userToken,
			page: this.state.activePage,
			count: this.state.count,
      sorting: sorting,
      status:this.state.status
		};

		this.props.actions.getAllSpecialists(appointmentObj);
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');

		let appointmentObj = {
			token: userToken,
			count: this.state.count,
			status: this.state.status,
			page: pageNumber,
			type: 'specialist'
		};
		this.props.actions.getAllSpecialists(appointmentObj);
	}

	handleChange(status, id) {
		let obj = {
			status: status,
			userId: id,
			page: this.state.activePage,
			count: this.state.count,
			verified: this.state.status,
		};
		this.props.actions.changeUserStatus(obj);
	}

	render() {
		var specialistList = this.state.specialistList;
		var rows = [];
		{
			this.state.specialistList.length > 0 ? this.state.specialistList.forEach(
				function (item, index) {
					var activated = item.users.isActivated == '2' ? '1' : '2'
					rows.push(
						<tr key={index}>
							<td>
								<Link>{item.users.userName}</Link>
							</td>
							<td>{item.qualification} </td>
							<td>
								{item.specializations.specialization}
							</td>
							<td>
								{item.users.email}
							</td>
							<td>
								{item.isAllVerified == false ? <Link to={"/user/verification/" + item.users._id}><img src={require('../../../images/images/verify.png')} width="40" height="30" /></Link> :
									<Switch
										onChange={this.handleChange.bind(this, activated, item.users._id)}
										checked={item.users.isActivated == '2' ? true : false}
										className="react-switch"
										// id={id}
										onColor="#00B6E4"
									/>
								}
							</td>
						</tr>
					);
				}.bind(this)
			) : <tr><td>No Records Found</td></tr>;
		}
		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li>
											<Link
												to="#tab_1"
												data-toggle="tab"
												className="active show"
												onClick={this.changeSpecialistType.bind(this, true)}
											>
												Verified Specialist Users
											</Link>
										</li>
										<li><Link to="#" data-toggle="tab" onClick={this.changeSpecialistType.bind(this, false)}>Non Verified Specialist Users</Link></li>
									</ul>
									<div className="uploadImg-btn" />
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable" id="tab_1">
													<div className="table-responsive">
														<table className="table">
															<tbody>
																<tr>
																	<th
																		onClick={this.sortChanged.bind(
																			this,
																			"users.userName",
																			this.state.sortOrder
																		)}
																	>
																		Name
                                    <i
																			className={this._sortClass(
																				"appointmentspecialistname"
																			)}
																		/>
																	</th>
																	<th
																		onClick={this.sortChanged.bind(
																			this,
																			"qualification",
																			this.state.sortOrder
																		)}
																	>
																		Qualification<i
																			className={this._sortClass(
																				"appointmentspecialistname"
																			)}
																		/>
																	</th>
																	<th
																		onClick={this.sortChanged.bind(
																			this,
																			"specializations.specialization",
																			this.state.sortOrder
																		)}
																	>
																		Specialization<i
																			className={this._sortClass(
																				"appointmentspecialistname"
																			)}
																		/>
																	</th>
																	<th
																		onClick={this.sortChanged.bind(
																			this,
																			"users.email",
																			this.state.sortOrder
																		)}
																	>
																		Email<i
																			className={this._sortClass(
																				"appointmentspecialistname"
																			)}
																		/>
																	</th>
																	<th>Action</th>
																</tr>
																{rows && rows.length > 0 ? (
																	rows
																) : (
																		<tr>
																			<td colSpan={4} className="text-center">
																				No users
                                    </td>
																		</tr>
																	)}
															</tbody>
														</table>
													</div></div>
												</div>
												{specialistList && specialistList.length > 0 ? (
													<div className="row">
														<div className="col-sm-5">
														<div className="showingEntries">
															Showing{" "}
															{this.state.activePage * this.state.count -
																(this.state.count - 1)}{" "}
															to{" "}
															{this.state.activePage * this.state.count >
																this.state.totalCount
																? this.state.totalCount
																: this.state.activePage * this.state.count}{" "}
															of {this.state.totalCount} entries
                            </div>  </div>
														<div
															className="col-sm-7 text-right"
															style={{ cursor: "pointer" }}
														>
															<Pagination
																prevPageText="Prev"
																nextPageText="Next"
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCount}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div>
												) : (
														""
													)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistList: state.vettingUser.specialistList.specialistData ? state.vettingUser.specialistList.specialistData : '',
		specialistListCount: state.vettingUser.specialistList.totalcount ? state.vettingUser.specialistList.totalcount : 0,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(vettingUserActions, dispatch),
		adminIndex: bindActionCreators(adminIndex, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecilaistUserList);


